import { MessagesPage } from '@/pages/Messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/messages')({
  component: MessagesPage,
})
